import { BookOpen, Clock3, Radio, ShieldAlert, Sparkles, Wrench } from "lucide-react";

import { formatGameTime } from "../lib/format";
import type { GameState } from "../types";
import { EventArtwork, type EventArtworkVariant } from "./EventArtwork";

function eventIcon(kind: string) {
  if (kind.includes("attack")) return ShieldAlert;
  if (kind.includes("expedition")) return Radio;
  if (kind.includes("complete") || kind.includes("task")) return Wrench;
  return Sparkles;
}

export function artworkForJournalEvent(kind: string, message = ""): EventArtworkVariant | null {
  const evidence = `${kind} ${message}`.toLowerCase();
  if (["death", "dead", "killed", "fatal", "casualty", "memorial"].some((term) => evidence.includes(term))) return "memorial";
  if (evidence.includes("research")) return "research_breakthrough";
  if (evidence.includes("expedition") && ["return", "home", "complete"].some((term) => evidence.includes(term))) return "expedition_return";
  if (["build", "excavat", "repair", "construction", "relocat", "new bunker"].some((term) => evidence.includes(term))) return "bunker_rebuild";
  if (evidence.includes("attack") || evidence.includes("horde")) return "contact";
  return null;
}

export function JournalPanel({ state }: { state: GameState }) {
  const events = [...state.journal].reverse();
  const illustrated = new Set<EventArtworkVariant>();
  const entries = events.map((event) => {
    const candidate = artworkForJournalEvent(event.kind, event.message);
    const artwork = candidate && !illustrated.has(candidate) ? candidate : null;
    if (artwork) illustrated.add(artwork);
    return { event, artwork };
  });
  return (
    <section className="journal-layout panel-surface">
      <header><div><span className="eyebrow">Community record</span><h2>What happened here matters.</h2><p>The journal records witnessed events—not everything that may be true.</p></div><BookOpen size={35} /></header>
      <div className="journal-timeline">{entries.map(({ event, artwork }) => { const Icon = eventIcon(event.kind); return <article className={artwork ? "journal-entry-illustrated" : ""} key={event.sequence}><div className="journal-time"><Clock3 size={12} /><span>{formatGameTime(event.game_time)}</span></div><div className="journal-mark"><Icon size={15} /></div><div><small>{event.kind.replaceAll("_", " ")}</small><p>{event.message}</p>{artwork && <EventArtwork compact variant={artwork} caption="Recovered visual record" />}</div></article>; })}</div>
    </section>
  );
}
